import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-template-header-action',
  styleUrls: ['./form-template-header-action.component.scss'],
  templateUrl: './form-template-header-action.component.html',
})
export class FormTemplateHeaderActionComponent {
  @Input() headerAction: any;

  actioned(value: any): void {
    if (!this.headerAction.callback) {
      return;
    }
    return this.headerAction.callback(value);
  }
}
